import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Card } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { MapPin, Search, ArrowRight, BookOpen } from "lucide-react";

export default function CitiesPublic() {
  const [cities, setCities] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => { api.get("/cities").then((r) => setCities(r.data)).catch(() => {}); }, []);

  const filtered = cities.filter((c) => !search || c.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <span className="text-xs uppercase tracking-[0.2em] text-blue-900 font-bold">Cidades parceiras</span>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-stone-900 mt-2">Encontre sua cidade</h1>
        <p className="text-stone-600 mt-3">Explore o comércio local de cada uma e ganhe BemCash em cada compra.</p>
      </div>

      <Card className="p-2 rounded-2xl border-stone-200 flex items-center gap-2 mb-8 max-w-md mx-auto">
        <Search size={16} className="text-stone-400 ml-2"/>
        <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Filtrar cidade..."
          className="rounded-xl border-0 focus-visible:ring-0" data-testid="cities-search"/>
      </Card>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        {filtered.map((c) => (
          <Link key={c.slug} to={`/discover/${c.slug}`}
            className="group relative overflow-hidden rounded-3xl bg-white border border-stone-200 hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
            data-testid={`city-card-${c.slug}`}>
            {c.cover_image ? (
              <div className="aspect-[16/10] overflow-hidden">
                <img src={c.cover_image} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
              </div>
            ) : (
              <div className="aspect-[16/10] bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center text-blue-900 font-display text-3xl"><MapPin size={32}/></div>
            )}
            <div className="p-5">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-display text-xl font-semibold text-stone-900">{c.name}</h3>
                  <p className="text-xs text-stone-500 mt-0.5">{c.state}</p>
                </div>
                <ArrowRight size={18} className="text-blue-900 group-hover:translate-x-1 transition-transform"/>
              </div>
              {(() => {
                const hasCovers = (Array.isArray(c.guide_covers) && c.guide_covers.length > 0) || !!c.guide_cover_url;
                if (hasCovers) {
                  return (
                    <span
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); window.location.href = `/guia/${c.slug}`; }}
                      className="mt-3 inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider px-2 py-1 rounded-full bg-amber-100 text-amber-900 hover:bg-amber-200 cursor-pointer"
                      data-testid={`city-guide-link-${c.slug}`}
                    >
                      <BookOpen size={11}/> Ver capas
                    </span>
                  );
                }
                return (
                  <span className="mt-3 inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider px-2 py-1 rounded-full bg-stone-100 text-stone-500" data-testid={`city-guide-coming-${c.slug}`}>
                    Guia em breve
                  </span>
                );
              })()}
            </div>
          </Link>
        ))}
        {filtered.length === 0 && <p className="col-span-full text-center text-stone-500 py-10">Nenhuma cidade encontrada.</p>}
      </div>
    </div>
  );
}
